<template>
    <div class="main_body">
        <div class="input_search mb-4">
            <input v-model="model_find" @keypress.enter="find" type="text" placeholder="Search" class="form-control">
            <svg @click="find" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
            </svg>
        </div>        
        <div v-if="!find_persons">
            <button @click="addCategory" class="btn btn-primary">+ ADD CATEGORY</button>
            <table class="table mt-5">
                <tr>
                    <th>Name</th>
                </tr>
                <tr v-for="(category, key) in categoriesItem" :key="category.id">
                    <td>
                        <div :class="`category_item black_block border_left ${category.icon_base64}`">
                            <div class="category_item__left"><a :href="`/categories/${category.id}`">{{category.name}}</a></div>
                            <div class="category_item__right">
                                <div>{{category.countperson}} items</div>
                                <div class="dotscontrol" >
                                    <div class="dotscontrol_dots" type="button" :id="`dropdownMenuButton${key}`" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span class="dotscontrol_dots__span"></span>
                                    </div>
                                    <ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton${key}`">
                                        <li><a @click="editCategory(category)"  class="dropdown-item" href="#">EDIT</a></li>
                                        <li><a @click="removeCategory(category.id)" class="dropdown-item" >DELETE</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div v-else>
            <Control
                v-bind:add="false"
                v-bind:move="true"
                v-bind:del="true"
                :category_id="category_id"
                :listdelete = "listdelete"
            />            
            <persons-list
                :model_find_prop= "model_find"            
                :category_id_prop = null
            />
        </div>
    </div>
</template>

<script>

import {bus} from '../bus';
import axios from 'axios';
import PersonsList from './Persons/PersonsList.vue';
import Control from './Persons/Control.vue';


export default {
    props: ['categories'],
    data(){
        return{
            cat: [],
            model_find: '',
            find_persons: false
        }
    },
    methods: {
        find(){            
            this.find_persons = this.model_find;
            bus.$emit('getListPerson');            
        },
        addCategory(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'category',
                'crud': 'create',
            })
        },
        getCategories(){
            axios.get('/getcategories')
                .then( (response) => {
                    // handle success
                    console.log('update categories', response.data);
                    // this.data = response.data;
                    this.cat = response.data;
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
        },
        removeCategory(id){

            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

            axios.delete('/categories/'+id)
                .then( (response) => {

                    this.getCategories();
                    console.log('remove' , response.data);

                }).catch(function (error) {
                // handle error
                console.log(error);
            });

        },
        editCategory(category){
            console.log(category);
            bus.$emit('openpopup', {
                'open': true,
                'type': 'category',
                'crud': 'edit',
                'data': category
            })
        },
        findcategories(){

            if(this.model_find.length > 0){
                axios.post('/findcategories', {
                    find: this.model_find
                })
                    .then( (response) => {
                        // handle success
                        console.log('find categories', response.data);
                        // this.data = response.data;
                        this.cat = response.data;
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
            }else{
                this.getCategories();
            }

        }
    },
    mounted(){
        // this.cat = this.categories;
        this.getCategories();

        bus.$on('addcategory', (data) => {
            // this.categories.push(data);

            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

            axios.post('/categories', data)
                .then((response) => {
                    // handle success
                    console.log('handle success', response.data);
                    console.log(typeof response.data);
                    // Refresh so countperson comes from SDK SoT (/getcategories),
                    // not a stale client push without badge counts.
                    this.getCategories();
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })

        });

        bus.$on('editcategory', (data) => {

            // this.categories.push(data);

            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

            axios.put('/categories', data)
                .then((response) => {
                    // handle success
                    console.log('handle success', response.data);

                    this.getCategories();
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })

        });

        bus.$on('update_category', (data) => {
            if(data){
                this.getCategories();
            }
        });
    },
    computed: {
        categoriesItem(){
            return this.cat;
        }
    },
    components: {
        PersonsList,
        Control
    }
}
</script>

<style scoped>

</style>
